module.exports = {
  REPATRIATIONS_TRANSACTIONS_CREATE_REQUEST: 'REPATRIATIONS_TRANSACTIONS_CREATE_REQUEST',
  REPATRIATIONS_TRANSACTIONS_CREATE_SUCCESS: 'REPATRIATIONS_TRANSACTIONS_CREATE_SUCCESS',
  REPATRIATIONS_TRANSACTIONS_CREATE_FAILURE: 'REPATRIATIONS_TRANSACTIONS_CREATE_FAILURE',
};
